import { createSlice } from "@reduxjs/toolkit";
import * as app_consts from "../../utils/app_consts";

const initialState = {
 add_product_stock: { message: "idle" },
};

export const add_product_stock_Slice = createSlice({
 name: "add_product_stock",
 initialState,
 reducers: {
  success_add_product_stock: (state, action) => {
   state.add_product_stock = { status: app_consts.SUCCESS, data: action.payload };
   // Clear Exact Token
  },
  fail_add_product_stock: (state, action) => {
   state.add_product_stock = { status: app_consts.FAIL, message: action.payload };
  },
  reset_add_product_stock: (state) => {
   state.add_product_stock = { status: app_consts.IDLE };
  },
  loading_add_product_stock: (state) => {
   state.add_product_stock = { status: app_consts.LOADING };
  },
 }
});

export const { success_add_product_stock, fail_add_product_stock, reset_add_product_stock, loading_add_product_stock } = add_product_stock_Slice.actions;

export default add_product_stock_Slice.reducer;